export default __webpack_public_path__ + "static/media/mar-analysis.28bfbad6.png";